var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.3 11.696-1.17-.495c-.18-.09-.337-.326-.337-.529V7.23c0-1.08-.798-2.363-1.766-2.858a1.215 1.215 0 0 0-1.08 0c-.956.495-1.755 1.789-1.755 2.869v3.442c0 .203-.157.44-.337.53l-6.413 2.755c-.709.293-1.282 1.182-1.282 1.947V17.4c0 .956.72 1.428 1.608 1.046l5.637-2.43c.438-.191.798.045.798.529V19.818c0 .26-.146.63-.326.81l-2.61 2.622c-.27.27-.394.798-.27 1.18l.506 1.53c.203.665.957.98 1.575.665l2.678-2.25a1.169 1.169 0 0 1 1.474 0l2.677 2.25a1.15 1.15 0 0 0 1.598-.664l.506-1.53c.124-.371 0-.911-.27-1.181l-2.61-2.622c-.191-.18-.338-.55-.338-.81v-3.273c0-.484.35-.71.8-.53l5.635 2.43c.89.383 1.61-.09 1.61-1.045v-1.485c0-.765-.575-1.654-1.283-1.958L18.3 11.696z",
    fill: "#ED1C24",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon-10.995e8283397c8840225810a36de7a4da.svg";
export { ForwardRef as ReactComponent };